import { useMediaQuery } from "@mui/material";

export const useIsDesktop = (options) => {
  return useMediaQuery(({ breakpoints }) => breakpoints.up("md"), options);
};
